<template>
  <div class="subcategory-group" :key="key">
    <div v-for="(subcategory, index) of subcategoryGroup" :key="index">
      <div>
        <SubcategoryCheckbox v-model="subcategoriesSelected" :subcategory="subcategory" />
      </div>
      <div class="horizontal-separator" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaPlayerSubcategoryGroup',
  components: {
    SubcategoryCheckbox: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerSubcategoryCheckbox'),
  },
  props: {
    fatherCategoryId: {
      type: [Number, String],
      required: true,
    },
    subcategoryGroup: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      key: `${this.fatherCategoryId}`,
      keyCounter: 0,
      subcategoriesSelected: [],
      subcategoryGroupMap: new Map(),
    };
  },
  watch: {
    subcategoryGroup: {
      immediate: true,
      handler(newValue) {
        this.subcategoriesSelected = [];
        newValue.forEach(subcategory => {
          this.subcategoriesSelected.push(subcategory.groupId);
          subcategory.isSelected = true;
        });
      },
    },
    subcategoriesSelected(newValue, oldValue) {
      if (!newValue.length) {
        this.keyCounter++;
        this.subcategoriesSelected = oldValue;
        this.key = `${this.fatherCategoryId}-${this.keyCounter}`;
      } else if (newValue.length) {
        this.subcategoryGroup.forEach(subcategory => {
          subcategory.isSelected = newValue.includes(subcategory.groupId);
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.subcategory-group {
  font-size: 0.8125rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & > div {
    margin: 0.1em 0;
  }
}
</style>
